<template>
  <div>
    <p class="mb-4">
      Este estudio se ha realizado mediante una encuesta telefónica asistida por
      ordenador (CATI), tomando por universo de estudio toda la población
      residente en España, de dieciocho años o más. Para su realización se
      diseñó un cuestionario estructurado con preguntas abiertas y cerradas, con
      una duración media de 25 minutos.
    </p>
    <p class="mb-4">
      El trabajo de campo se realizó en dos fases diferenciadas debido al
      surgimiento de la pandemia de la COVID-19 y el confinamiento decretado por
      el Gobierno. La primera de ellas abarcó del 10 de febrero hasta el 13 de
      marzo, y la segunda del 24 de agosto al 8 de septiembre de 2020. La
      muestra finalmente recogida es de 4.769 entrevistas, lo que implica un
      error total del ±2%, partiendo de los supuestos habituales de un muestreo
      aleatorio simple, máxima heterogeneidad (P=Q) y un intervalo de confianza
      del 95,5%.
    </p>
    <p class="mb-4">
      La distribución final de la muestra se ha realizado conforme a la
      siguiente tabla:
    </p>

    <!-- This example requires Tailwind CSS v2.0+ -->
    <div class="flex flex-col mb-4">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div class="overflow-hidden">
            <table class="min-w-full ">
              <thead class="bg-primary">
                <tr>
                  <th
                    scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
                  >
                    Comunidad autónoma
                  </th>
                  <th
                    scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
                  >
                    Muestra diseñada
                  </th>
                  <th
                    scope="col"
                    class="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
                  >
                    Muestra realizada
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="row in comunidades" :key="row.name">
                  <td
                    class="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900"
                  >
                    {{ row.name }}
                  </td>
                  <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                    {{ row.muestra1 }}
                  </td>
                  <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                    {{ row.muestra2 }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <p class="mb-4">
      A su vez, a lo largo de este informe la persona usuaria podrá segmentar
      las respuestas otorgadas por las personas entrevistadas atendiendo a
      criterios como el sexo, la edad, la cercanía con el cáncer (si ha padecido
      cáncer personalmente, si tiene algún familiar que lo haya padecido, o
      ninguna de las dos) o el estrato social. Estos estratos sociales han sido
      codificados en función de la profesión de la persona entrevistada de la
      siguiente manera:
    </p>

    <ul class="space-y-4 italic mb-6">
      <li>
        Grupo I: Gerentes con más de 10 asalariados y profesiones asociadas a
        licenciaturas universitarias.
      </li>
      <li>
        Grupo II: Gerentes con menos de 10 asalariados y profesiones asociadas a
        diplomaturas universitarias.
      </li>
      <li>
        Grupo III: Ocupaciones intermedias y trabajadores por cuenta propia.
      </li>
      <li>
        Grupo IV: Trabajadores en ocupaciones técnicas cualificadas o
        semicualificadas.
      </li>
      <li>Grupo V: Trabajadores no cualificados</li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      comunidades: [
        { name: "Andalucía", muestra1: 845, muestra2: 880 },
        { name: "Aragón", muestra1: 136, muestra2: 147 },
        { name: "Asturias", muestra1: 110, muestra2: 115 },
        { name: "Islas Baleares", muestra1: 121, muestra2: 120 },
        { name: "Canarias", muestra1: 229, muestra2: 193 },
        { name: "Cantabria", muestra1: 61, muestra2: 70 },
        { name: "Castilla - La Mancha", muestra1: 206, muestra2: 217 },
        { name: "Castilla y León", muestra1: 255, muestra2: 244 },
        { name: "Cataluña", muestra1: 763, muestra2: 740 },
        { name: "Comunidad Valenciana", muestra1: 506, muestra2: 471 },
        { name: "Extremadura", muestra1: 110, muestra2: 123 },
        { name: "Galicia", muestra1: 287, muestra2: 270 },
        { name: "Madrid", muestra1: 671, muestra2: 728 },
        { name: "Murcia", muestra1: 146, muestra2: 164 },
        { name: "Navarra", muestra1: 66, muestra2: 71 },
        { name: "País Vasco", muestra1: 224, muestra2: 180 },
        { name: "La Rioja", muestra1: 32, muestra2: 36 },
        { name: "TOTAL", muestra1: 4769, muestra2: 4769 },
      ],
    };
  },
};
</script>

<style></style>
